<template>
	<div>	
		<div class="footBox">
		<div style="display: flex;justify-content: space-between;align-items: center;">
			<div style="line-height: 2rem;">
				<div style="width: 16.6875rem; height: 3.5625rem;">
					<img src="../assets/images/footLogo.png" alt=""  style="width: 100%; height: 100%; object-fit: contain;">
				</div>
				<div style="display: flex;align-items: center;cursor: pointer;margin-top: 2rem;" @click="showMap = true">
					<span style="display: inline-block;width:1.5rem ;height:1.5rem;margin-right: 0.5rem;">
						<img src="../assets/images/dingwei.svg" alt="" style="width: 100%;height: 100%;object-fit: contain;">
					</span>
					<span>查看路线</span>
				</div>
				<div style="display: flex;align-items: center;">
					<span style="display: inline-block;width:1.5rem ;height:1.5rem;margin-right: 0.5rem;">
						<img src="../assets/images/phone.png" alt="" style="width: 100%;height: 100%;object-fit: contain;">
					</span>
					<span>021-31588888</span>
				</div>
				<div style="display: flex;align-items: center;">
					<span style="display: inline-block;width:1.5rem ;height:1.5rem;margin-right: 0.5rem;">
						<img src="../assets/images/mapicon.png" alt="" style="width: 100%;height: 100%;object-fit: contain;">
					</span>
					<span>上海市崇明区陈家镇东滩大道200号</span>
				</div>
			</div>
			<div>
				
				<div class="footNav">
					<div v-for="(item,index) in navlist" :key="index" class="footNavBox">
						<div>{{item.title}}</div>
						<div class="line"></div>
						<div class="footNavItem">
							<span v-for="(item2,index2) in item.content" :key="index2" @click="path(item2)" style="cursor: pointer;">{{item2.title}}</span>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
	<div v-if="showMap" style="width: 100%; height: auto;position: fixed;top: 50%;left: 50%;transform: translate(-50%,-50%);z-index: 9999;">
		<img src="../assets/images/map.png" alt="" style="width: 100%;height: 100%;object-fit: contain;">
		<div class="closeBTN"  @click="showMap = false">
			<img src="../assets/images/close.svg" alt="" style="width: 100%;height: 100%;object-fit: contain;">
		</div>
	</div>
	<div class="smallfootBox"  >  
			<!-- <img src="../assets/images/map.png" alt=""  class="footerImg"> -->
			<div class="footer">
				<!-- <div class="fastLink">
					<a class="rightItem" v-for="(item,index) in list">{{item}}</a>
				</div> -->
				<div class="concatUs">
					<div class="hospitalBox">
						<div class="flex" @click="showMap = true">
							<img src="../assets/images/dingwei.svg" alt="" width="16px" height="16px">
							<span>查看路线					</span>
						</div>
						<div class="flex">
							<img src="../assets/images/phone.png" alt="" width="16px" height="16px">
							<span>02131588888						</span>
						</div>
						<div class="flex">
							<img src="../assets/images/mapicon.png" alt="" width="16px" height="16px">
							<span>上海市崇明区陈家镇东滩大道200号</span>
						</div>
					</div>
				</div>
			</div>
		</div>  
	</div>
</template>

<script>

	import {GetTalentRecruitment} from '@/api/api'

	export default{
		data(){
			return{
				showMap:false,
				navlist:[
					{title:'特色功能中心',url:'',
						content:[
							{title:'健康体检中心',url:'/artile',current:4,guid:'69e65621-a371-4f11-bac3-a01698dad7d9'},
							{title:'医学影像中心',url:'/artile',current:4,guid:'2e6d02ac-13f8-474a-ab24-7077e9565e81'},
							{title:'精准检验中心',url:'/artile',current:4,guid:'6ad18ba6-5f27-4ad0-87b9-6312bcbed6fe'},
							{title:'慢病管理中心',url:'/artile',current:4,guid:'3b512472-50d8-4550-af82-cac14f1e3ad5'},
							{title:'康复理疗中心',url:'/artile',current:4,guid:'086b99a6-a98d-4372-a8f0-07df2303d617'},
							{title:'高压氧疗中心',url:'/artile',current:4,guid:'04e1cbcc-9fc1-42c6-a43d-4ad37e3da687'},
							{title:'消化内镜中心',url:'/artile',current:4,guid:'459898df-aebd-4b1f-b4d9-c6168737a47a'},
						],
					},
					{title:'专家团队',url:'',
						content:[
							{title:'科室介绍',url:'/ExpertTeam'},
							{title:'专家介绍',url:'/DoctorTeam'},
						],
					},
					{title:'生态岛环境',url:'',
						content:[
							{title:'长寿岛',url:'/artile',current:1,guid:'8dca3b51-f33d-4498-b620-4e775d1fb87c'},
							{title:'候鸟天堂',url:'/artile',current:1,guid:'b1830963-a24f-450a-a3ae-c86bfb883976'},
							{title:'湿地公园',url:'/artile',current:1,guid:'c8ce7882-afbb-4479-b9ba-a38d865cc19a'},
							{title:'天然氧吧',url:'/artile',current:1,guid:'b337ec1b-1657-4a1d-b437-d22e825b73d1'},
						],
					},
					{title:'新闻资讯',url:'',
						// content:[
						// 	{title:'体检介绍',url:'/HealthIntro'},
						// 	{title:'常规体检',url:'/PhysicalExamination'},
						// 	{title:'VIP体检',url:'/vipPE'},
						// ],
					},
					
					// {title:'康复疗养',url:'',
					// 	content:[
					// 		{title:'运动康复',url:'/artile',current:5,guid:'5699a212-98a4-4358-b28f-3b0f3a1ff160'},
					// 		{title:'中医理疗',url:'/artile',current:5,guid:'81b6eab0-a251-46ae-9e40-735894de6514'},
					// 		{title:'音乐疗法',url:'/artile',current:5,guid:'26c48817-69d0-44b5-9311-07cde32005ac'},
					// 	],
					// },
					// {title:'特色服务',url:'',
					// 	content:[
					// 		{title:'基因检测',url:'/artile',current:6,guid:'ff5835b4-2252-4b02-9b01-fa4ffa8b624f'},
					// 		{title:'DNA甲基化检测',url:'/artile',current:6,guid:'b4dbef1a-b54c-4bec-96a3-e0b6137376ae'},
					// 	],
					// },
				],
			}
		},
		mounted() {
			// this.GetData();
		},
		methods:{
			GetData(){
				GetTalentRecruitment({categoryId: 16,status: 1}).then(res => {
					let guid=res.data.data.rows[0].guid
					GetTalentRecruitment({guid: guid}).then(res => {
					    this.info=res.data.data.rows[0]
						console.log(this.info)
					})
					
				})
			},
			path(item){
				if(item.url.indexOf('artile') >= 0) {
					this.$router.push({ 
						path: '/artile', 
						query: { current: item.current, guid: item.guid } ,
					})
					location.reload()
				} else {
				   this.$router.push(item.url)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.footBox{
		min-width: $commoneWidth;
		background-color:$baseColor;
		color:#ffffff;
		margin: 0 auto;
		font-size: 1.125rem;
		padding:  2.5rem 5rem;
	}
	.footNav{
		display: flex;
		// margin-top: 2rem;
		.footNavBox{
			margin-right: 6rem;
			.line{
				width: 2rem;
				height: 0.0625rem;
				background-color: #ffffff;
				margin-top: 0.5rem;
				opacity: .8;
			}
			.footNavItem{
				display: flex;
				flex-direction: column;
				margin-top: 1.25rem;
				cursor: pointer;
				span{
					font-size: 0.875rem;
					color: #ffffff;
					line-height: 1.8rem;
					opacity: .8;
					cursor: pointer;
					&:hover{
						opacity: 1;
					}
				}
			}
		}
		
	}
	.closeBTN{
		position: absolute;
		top: 1rem;
		right: 1rem;
		width: 2rem;
		height: 2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: transform 0.3s ease;
		
		&:hover {
			transform: rotate(180deg);
		}
	}
	@media screen and (min-width: 769px) {//pc版本
		.smallfootBox{display: none;}
	}
	@media screen and (max-width: 768px) {//手机版本
		.footBox{display: none;}
		.smallfootBox{
			font-size: 12px;
			background-color:$baseColor;
			color:#ffffff;
			margin: 0 auto;
			width: 100%;
			.fastLink{
				white-space: nowrap; /* 防止换行 */
				.rightItem{margin-right: 4px; white-space: nowrap; /* 防止换行 */}
			}
			.concatUs{
				padding: 10px;
				line-height: 26px;
			}
		}
		.footerImg{
			width: auto;
			height: 100px;
		}
		
	}
	.flex{
		display: flex;
		align-items: center;
		img{
			margin-right: 8px;
		}
	}
	
</style>
